export const baseUrl="https://www.happy-weekends.com/admin/public/api/";
export const baseImgUrl="https://www.happy-weekends.com/admin/public/";
export const mainUrl="https://www.happy-weekends.com/";

// export const baseUrl="http://www.neukron.com/admin/public/api/";
// export const baseImgUrl="http://www.neukron.com/admin/public/";